import history from "core/helper/Helper";
import React from "react";

import styles from "./MenuLogo.module.css";
import { RouterName } from "shared/RouterName";

const MenuLogoItem = () => {
  return (
    <span
      className={styles.logo}
      onClick={() => {
        history.push(RouterName.HomePage.url);
      }}
    >
      <span>Kunlez</span>
    </span>
  );
};

export default MenuLogoItem;
